// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 인증 페이지 스타일 */
.auth-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 30%, #a5d6a7 70%, #b9e4c9 100%);
  padding: 20px;
  position: relative;
}

/* 페이지 헤더 - 왼쪽 상단 */
.page-header {
  position: absolute;
  top: 30px;
  left: 40px;
  z-index: 10;
}

.page-title {
  font-size: 36px;
  font-weight: bold;
  color: #2e7d32;
  margin: 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 1px;
}

.page-subtitle {
  font-size: 18px;
  color: #4a7c4e;
  margin: 5px 0 0 0;
  font-weight: 400;
  text-shadow: none;
}

.auth-wrapper {
  width: 100%;
  max-width: 450px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.auth-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: 40px;
  width: 100%;
}

.auth-card.signup-card {
  max-width: 600px;
}

.auth-header {
  text-align: center;
  margin-bottom: 32px;
}

.auth-title {
  font-size: 28px;
  font-weight: bold;
  color: #388e3c;
  margin-bottom: 8px;
}

.auth-subtitle {
  font-size: 14px;
  color: #5a7c65;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #4a7c4e;
}

.form-label.required::after {
  content: ' *';
  color: #e53e3e;
}

.form-input {
  padding: 10px 14px;
  border: 1px solid #d4e8d4;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  outline: none;
  background-color: #fafffe;
}

.form-input:focus {
  border-color: #66bb6a;
  box-shadow: 0 0 0 3px rgba(102, 187, 106, 0.15);
  background-color: white;
}

.form-input.error {
  border-color: #fc8181;
  background-color: #fff5f5;
}

.form-input:disabled {
  background-color: #f0f4f0;
  cursor: not-allowed;
}

.field-error {
  font-size: 12px;
  color: #e53e3e;
  margin-top: 4px;
}

.error-message {
  background-color: #fed7d7;
  color: #9b2c2c;
  padding: 12px;
  border-radius: 6px;
  font-size: 14px;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #4a7c4e;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #66bb6a;
}

.link-text {
  color: #388e3c;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
  font-weight: 500;
}

.link-text:hover {
  color: #66bb6a;
  text-decoration: underline;
}

.submit-btn {
  background: linear-gradient(135deg, #66bb6a 0%, #81c784 100%);
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 6px rgba(102, 187, 106, 0.2);
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(102, 187, 106, 0.3);
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.auth-footer {
  text-align: center;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e8f5e9;
  font-size: 14px;
  color: #4a5568;
}

/* 테스트 계정 정보 박스 스타일 개선 */
.test-account-info {
  margin-top: 20px;
  padding: 15px;
  background: linear-gradient(135deg, #e8f5e9 0%, #f1f8f4 100%);
  border: 1px solid #a5d6a7;
  border-radius: 8px;
}

.test-account-info p {
  margin: 0;
  padding: 2px 0;
}

.test-account-info p:first-child {
  font-size: 14px;
  font-weight: bold;
  color: #388e3c;
  margin-bottom: 8px;
}

.test-account-info p:not(:first-child) {
  font-size: 13px;
  color: #5a7c65;
  font-family: 'Courier New', monospace;
}

/* 권한 없음 페이지 */
.unauthorized-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 30%, #a5d6a7 70%, #b9e4c9 100%);
}

.unauthorized-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.unauthorized-content h1 {
  font-size: 24px;
  color: #2d3748;
  margin-bottom: 12px;
}

.unauthorized-content p {
  color: #718096;
  margin-bottom: 24px;
}

.back-btn {
  background: linear-gradient(135deg, #66bb6a 0%, #81c784 100%);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
}

.back-btn:hover {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(102, 187, 106, 0.2);
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .page-header {
    top: 20px;
    left: 20px;
  }
  
  .page-title {
    font-size: 28px;
  }
  
  .page-subtitle {
    font-size: 16px;
  }
}

@media (max-width: 640px) {
  .auth-card.signup-card {
    padding: 24px;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .auth-title {
    font-size: 24px;
  }
  
  .page-title {
    font-size: 24px;
  }
  
  .page-subtitle {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/auth.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uFAAuF;EACvF,aAAa;EACb,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;AACvC;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uFAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,YAAY;AACZ;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* 인증 페이지 스타일 */\n.auth-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 30%, #a5d6a7 70%, #b9e4c9 100%);\n  padding: 20px;\n  position: relative;\n}\n\n/* 페이지 헤더 - 왼쪽 상단 */\n.page-header {\n  position: absolute;\n  top: 30px;\n  left: 40px;\n  z-index: 10;\n}\n\n.page-title {\n  font-size: 36px;\n  font-weight: bold;\n  color: #2e7d32;\n  margin: 0;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 1px;\n}\n\n.page-subtitle {\n  font-size: 18px;\n  color: #4a7c4e;\n  margin: 5px 0 0 0;\n  font-weight: 400;\n  text-shadow: none;\n}\n\n.auth-wrapper {\n  width: 100%;\n  max-width: 450px;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n}\n\n.auth-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  padding: 40px;\n  width: 100%;\n}\n\n.auth-card.signup-card {\n  max-width: 600px;\n}\n\n.auth-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.auth-title {\n  font-size: 28px;\n  font-weight: bold;\n  color: #388e3c;\n  margin-bottom: 8px;\n}\n\n.auth-subtitle {\n  font-size: 14px;\n  color: #5a7c65;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #4a7c4e;\n}\n\n.form-label.required::after {\n  content: ' *';\n  color: #e53e3e;\n}\n\n.form-input {\n  padding: 10px 14px;\n  border: 1px solid #d4e8d4;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s;\n  outline: none;\n  background-color: #fafffe;\n}\n\n.form-input:focus {\n  border-color: #66bb6a;\n  box-shadow: 0 0 0 3px rgba(102, 187, 106, 0.15);\n  background-color: white;\n}\n\n.form-input.error {\n  border-color: #fc8181;\n  background-color: #fff5f5;\n}\n\n.form-input:disabled {\n  background-color: #f0f4f0;\n  cursor: not-allowed;\n}\n\n.field-error {\n  font-size: 12px;\n  color: #e53e3e;\n  margin-top: 4px;\n}\n\n.error-message {\n  background-color: #fed7d7;\n  color: #9b2c2c;\n  padding: 12px;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.form-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #4a7c4e;\n  cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #66bb6a;\n}\n\n.link-text {\n  color: #388e3c;\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 0.2s;\n  font-weight: 500;\n}\n\n.link-text:hover {\n  color: #66bb6a;\n  text-decoration: underline;\n}\n\n.submit-btn {\n  background: linear-gradient(135deg, #66bb6a 0%, #81c784 100%);\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  box-shadow: 0 4px 6px rgba(102, 187, 106, 0.2);\n}\n\n.submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(102, 187, 106, 0.3);\n  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.auth-footer {\n  text-align: center;\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid #e8f5e9;\n  font-size: 14px;\n  color: #4a5568;\n}\n\n/* 테스트 계정 정보 박스 스타일 개선 */\n.test-account-info {\n  margin-top: 20px;\n  padding: 15px;\n  background: linear-gradient(135deg, #e8f5e9 0%, #f1f8f4 100%);\n  border: 1px solid #a5d6a7;\n  border-radius: 8px;\n}\n\n.test-account-info p {\n  margin: 0;\n  padding: 2px 0;\n}\n\n.test-account-info p:first-child {\n  font-size: 14px;\n  font-weight: bold;\n  color: #388e3c;\n  margin-bottom: 8px;\n}\n\n.test-account-info p:not(:first-child) {\n  font-size: 13px;\n  color: #5a7c65;\n  font-family: 'Courier New', monospace;\n}\n\n/* 권한 없음 페이지 */\n.unauthorized-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 30%, #a5d6a7 70%, #b9e4c9 100%);\n}\n\n.unauthorized-content {\n  text-align: center;\n  padding: 40px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.unauthorized-content h1 {\n  font-size: 24px;\n  color: #2d3748;\n  margin-bottom: 12px;\n}\n\n.unauthorized-content p {\n  color: #718096;\n  margin-bottom: 24px;\n}\n\n.back-btn {\n  background: linear-gradient(135deg, #66bb6a 0%, #81c784 100%);\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s;\n}\n\n.back-btn:hover {\n  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(102, 187, 106, 0.2);\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n  .page-header {\n    top: 20px;\n    left: 20px;\n  }\n  \n  .page-title {\n    font-size: 28px;\n  }\n  \n  .page-subtitle {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 640px) {\n  .auth-card.signup-card {\n    padding: 24px;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .auth-title {\n    font-size: 24px;\n  }\n  \n  .page-title {\n    font-size: 24px;\n  }\n  \n  .page-subtitle {\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
